module.exports = typeof window !== 'undefined' ? require('./GameController') : null
